import React from 'react';

import { useAuth } from '../../AuthContext';

type View = 'all' | 'user';

type Props = {
  view: View;
  allowed: View[];
  onChange: (view: View) => void;
};

const ViewToggle: React.FC<Props> = ({ view, allowed, onChange }) => {
  const { user } = useAuth();

  if (allowed.length <= 1) return null;

  return (
    <div className='filters d-flex align-items-center'>
      {allowed.map((v) => {
        const label = v === 'all' ? 'All Projects' : 'My Projects';
        const title =
          v === 'all' ? `Show all ${user?.accountName ?? ''} projects` : `Show only your projects`;

        return (
          <div
            key={v}
            className={`filter btn-${view === v ? 'active' : 'non-active'} me-2 d-flex align-items-center`}
            onClick={() => onChange(v)}
            title={title}
          >
            {label}
          </div>
        );
      })}
    </div>
  );
};

export default ViewToggle;
